import { FC, Fragment, ReactNode } from 'react';

type PROPS = {
  rightSideItems?: ReactNode[];
  leftSideItems?: ReactNode[];
};

const GlobalHeader: FC<PROPS> = ({ rightSideItems, leftSideItems }) => {
  return (
    <div className="bg-fill-tertiary">
      <div className="flex h-[60px] items-center justify-between px-[18px]">
        <div className="flex items-center justify-center gap-x-[20px]">
          {leftSideItems?.map((item) => (
            <Fragment key={Math.random()}>{item}</Fragment>
          ))}
        </div>
        <div className="flex items-center justify-center gap-x-[20px]">
          {rightSideItems?.map((item) => (
            <Fragment key={Math.random()}>{item}</Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GlobalHeader;
